import React, {useEffect, useState} from 'react'
import {Button, Card, Col, Divider, message, Row, Select, Space, Spin} from "antd";
import {Constants} from "../../utils/ConstantsUtils";
import NewsListCell from "../../containers/news/NewsListCell";
import {useNavigate} from "react-router-dom";
import {NewsApi} from "../../services/NewsApi";
import {useMount} from "ahooks";
import {ApiService} from "../../services/ApiService";

let options = {}
let page = 0

const NewsCenterPage = () => {
    const nav = useNavigate()
    const [loading, setLoading] = useState(true)
    const [news, setNews] = useState([])
    const [provinces, setProvinces] = useState([])
    const [hasMore, setHasMore] = useState(true)

    const requestNews = (replace = false) => {
        setLoading(true)
        NewsApi.list(page, 50, options.emo, options.province, options.keyword)
            .onSuccess(data => {
                if (data.length < 50) {
                    setHasMore(false)
                    message.success("已全部加载")
                }
                let oldData = []
                if (!replace) {
                    oldData = [...news]
                }
                setNews([...oldData, ...data])
            })
            .onComplete(() => setLoading(false))
    }

    useMount(() => {
        requestNews(true)
        ApiService.common.region.children("0")
            .onSuccess(setProvinces)
    });

    useEffect(() => {

    }, []);

    const handleNewsClick = (sid) => {
        nav('/news?sid=' + sid)
    }

    const handleOptionChange = (key, value) => {
        if (value === "all") {
            options[key] = null
        } else {
            options[key] = value
        }
        page = 0
        console.log(options)
        requestNews(true)
    }

    const handleNextPageClick = () => {
        page += 1
        requestNews(false)
    }

    return (
        <>
            <Card style={{marginBottom: 5}}>
                <Row gutter={16}>
                    <Col>
                        地区：
                        <Select showSearch defaultValue={["all"]}
                                onChange={value => handleOptionChange("province", value)}>
                            <Select.Option value="all">全国</Select.Option>
                            {
                                provinces.map(p => <Select.Option value={p.code}>{p.name}</Select.Option>)
                            }
                        </Select>
                    </Col>
                    <Col>
                        情绪：
                        <Select showSearch defaultValue={["all"]} onChange={value => handleOptionChange("emo", value)}>
                            <Select.Option value="all">全部</Select.Option>
                            {
                                Constants.newsEmotions.map(e =>
                                    <Select.Option value={e.value}>{e.name}</Select.Option>
                                )
                            }
                        </Select>
                    </Col>
                    <Col>
                        关键词：
                        <Select showSearch defaultValue={["all"]}
                                onChange={value => handleOptionChange("keyword", value)}>
                            <Select.Option value="all">全部</Select.Option>
                            <Select.Option value="统战">统战</Select.Option>
                            <Select.Option value="天主教">天主教</Select.Option>
                            <Select.Option value="基督教">基督教</Select.Option>
                            <Select.Option value="佛教">佛教</Select.Option>
                            <Select.Option value="道教">道教</Select.Option>
                            <Select.Option value="伊斯兰教">伊斯兰教</Select.Option>
                        </Select>
                    </Col>
                </Row>
            </Card>

            <Spin spinning={loading}>
                <Card>
                    <Space direction={'vertical'} split={<Divider style={{margin: '0'}}/>}>
                        {
                            news.map(n =>
                                <NewsListCell
                                    key={n.sid}
                                    news={n}
                                    onClick={(n) => handleNewsClick(n.sid)}
                                />
                            )
                        }
                    </Space>
                    {
                        hasMore && <Row justify={'center'}>
                            <Button loading={loading} onClick={() => handleNextPageClick()}>加载更多</Button>
                        </Row>
                    }
                </Card>
            </Spin>
        </>
    )
}

export default NewsCenterPage